import { atom } from 'recoil';

export const userCEMState = atom<any>({
  key: 'userCEMState',
  default: null,
});
